<section class="term-container" aria-labelledby="payment-policy-title">
  <h1 id="payment-policy-title" class="visually-hidden">{{'PaymentPolicyDescription' | translate}}</h1>
  <h3 class="term--subtitle" itemprop="name">{{'PaymentPolicyLastUpdated'| translate}}</h3>
  <div class="term-list" role="list">
    @for (item of paymentPolicyModel.items; track item.order) {
    <div class="term-card" role="listitem" itemscope itemtype="https://schema.org/LegalService">
      <h2 class="term-title" itemprop="name">{{item.order}}. {{ item.title }}</h2>
      <p class="term-content" itemprop="description" [innerHTML]="item.content"></p>
    </div>

    }
  </div>

  <script type="application/ld+json" [textContent]="paymentPolicyStructuredData"></script>
</section>